var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.media && _vm.media.media_type == "Documents" && _vm.media.type != "downloadable" && _vm.media.type != "pdf")?_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected >= (_vm.images.length - 1)),expression:"selected >= (images.length - 1)"}],attrs:{"src":_vm.media.google_path}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }